import { fetchItem, deleteItem, destroyAuction } from "../actions/auction_action";
import { fetchItemMeta } from "../actions/auction_meta_action";
import Helping from "../helpers/Helping";
import Service from "../helpers/service";
import { API_URL } from "../config/urls";
import { GET_AUCTION } from '../config/routes';
import { trackPromise } from 'react-promise-tracker'

let updateCallback = (res) => {

}


export const setAuctionError = (callback) => {

    updateCallback = callback;

}

export const getAll = (page, limit, search, sorting, sort_type, status, start_date, end_date, auctionType) => {
    return dispatch => {
        let data = {
            "action": "listing",
            "limit": limit,
            "page": page,
            "sort_type": sort_type,
            "sorting": sorting,
            "startDate": start_date,
            "endDate": end_date,
            "search": search,
            "status": status,
            "auction_type":auctionType
        };

        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + GET_AUCTION, data)
                .then(response => {
                    let total = response.data.payload.total;

                    dispatch(fetchItem(response.data.payload.items));
                    dispatch(
                        fetchItemMeta({
                            page: page,
                            limit: limit,
                            sorting: sorting,
                            sort_type: sort_type,
                            search: search,
                            status: status,
                            total: total,
                            start_date: start_date,
                            end_date: end_date,
                            no_Of_pages: Math.ceil(total / limit),
                            is_auction: false,
                            auctionType: auctionType
                        })
                    );
                })
                .catch(error => {
                    console.log(error);
                    dispatch(fetchItem([]));
                    dispatch(
                        fetchItemMeta({
                            page: page,
                            limit: limit,
                            sorting: sorting,
                            sort_type: sort_type,
                            search: search,
                            status: status,
                            total: 0,
                            start_date: start_date,
                            end_date: end_date,
                            no_Of_pages: page,
                            is_auction: false,
                            auctionType: auctionType
                        }));
                    Helping.redirectToLogin(error);
                    return updateCallback({
                        ...Helping.setNetworkRequestError(error, "fetching auctions")
                    })
                })
        )
    };
};

export const deleteAuctionItem = item => {
    return deleteItem(item);
};

export const destroy = key => {
    return dispatch => dispatch(destroyAuction(key));
}

